import React from 'react';

// Compact 3-dots typing indicator (used in Conversation list items & sidebar lists)
const typingAnimationStyle = `
  @keyframes typingAnimation {
    0% { transform: translateY(0); }
    50% { transform: translateY(-5px); }
    100% { transform: translateY(0); }
  }
`;

const TypingIndicator = ({
    color = '#1890ff',
    dotSize = 6,
    gap = 3,
    marginRight = 5
}) => {
    const dotStyle = {
        width: dotSize,
        height: dotSize,
        borderRadius: '50%',
        backgroundColor: color,
        display: 'inline-block',
        margin: '0 2px',
    };

    return (
        <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap,
            marginRight
        }}>
            <style dangerouslySetInnerHTML={{ __html: typingAnimationStyle }} />
            <div style={{
                ...dotStyle,
                animation: 'typingAnimation 1s infinite ease-in-out',
                animationDelay: '0s'
            }} />
            <div style={{
                ...dotStyle,
                animation: 'typingAnimation 1s infinite ease-in-out',
                animationDelay: '0.2s'
            }} />
            <div style={{
                ...dotStyle,
                animation: 'typingAnimation 1s infinite ease-in-out',
                animationDelay: '0.4s'
            }} />
        </div>
    );
};

export default TypingIndicator;













